// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__VI3uf","item":"Navbar_item__czMo8","active":"Navbar_active__cy5tg"};